import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Button, Modal, Alert, CloseButton } from "react-bootstrap";
import { ToastContainer, toast, Slide } from 'react-toastify';
import axios from "axios";
import AvatarEditor from 'react-avatar-editor';
import "../styles/FormProfile.css";
import 'react-toastify/dist/ReactToastify.css';

export default function SingleUser() {
    const notify = (type, message) => {
        const properties = {
          position: "bottom-right",
          transition: Slide,
          autoClose: 1900,
          draggable: true,
          closeOnClick: true,
          pauseOnHover: false,
        }

        if (toast[type]) {
            toast[type](message, properties); // e.g., toast.success("Success message")
        } else {
            toast(message, properties); // Default toast if type is unknown
        }

        // TODO custom css class
    }    

    const [userRole, setUserRole] = useState('');
    const [userId, setUserId] = useState('');
    const [selectedPfp, setSelectedPfp] = useState('');
    const userIdRef = useRef('');
    const userRoleRef = useRef('');
    const userPfpRef = useRef('');
    const [changePfpModal, setChangePfpModal] = useState(false);
    const [scale, setScale] = useState(1.2);  // Zoom level
    const editorRef = useRef(null); // Reference to AvatarEditor

    useEffect(() => {
        document.title = "User Profile";

        axios.post('https://docuquest-swu.swucite.tech/api_drts/checkSession.php', {}, { withCredentials: true })
        .then((res) => {
          //console.warn("is the session alive in singleuser? ", res.data);
          if (res.data.status === 1) {
            setUserId(res.data.id);
            userIdRef.current = res.data.id

            setUserRole(res.data.role);
            userRoleRef.current = res.data.role;

            const endpoint = res.data.role
            ? `https://docuquest-swu.swucite.tech/api_drts/users.php/${accountId}/`
            : `https://docuquest-swu.swucite.tech/api_drts/clients.php/${accountId}/`;

            axios.get(endpoint)
            .then((res) => {
                setDisplayData({
                    id: res.data.id || null,
                    firstname: res.data.firstname || "",
                    middlename: res.data.middlename || "",
                    lastname: res.data.lastname || "",
                    email: res.data.email || "",
                    phone: res.data.phone || "",
                    profilePicture: res.data.img_profile 
                        ? res.data.img_profile 
                        : "https://via.placeholder.com/150",
                    accountType: res.data.account_type || "",
                    oldPassword: res.data.password || "",
                    user_courses: [], 
                    user_courses: res.data.user_courses || [] 
                });
            })
            .catch((err) => {
                notify("warning", `${err}`);
                setErrorUser({ type: "danger", message: `Error fetching data: ${err}` });
            });
            
          } else {
            notify("error", `${res.data.message}`);
            //console.warn("Session error:", res.data.message);
          }

        })
        .catch((err) => {
          //console.error("ERROR: Your session cannot be found!", err);
  
        });        
    }, []);

    const navigate = useNavigate();
    const [stringTitle, setTitle] = useState("");

    const [errorPfp, setErrorPfp] = useState({
        type: "",
        message: ""
    });

    const [errorUser, setErrorUser] = useState({
        type: "",
        message: ""
    });

    const [errorPassword, setErrorPassword] = useState({
        type: "",
        message: ""
    });
    
    const [displayData, setDisplayData] = useState({
        id: null,
        firstname: "",
        middlename: "",
        lastname: "",
        email: "",
        phone: "",
        profilePicture: "https://via.placeholder.com/150",
        accountType: "N/A",
        oldPassword: "",
        user_courses: []
    });
    
    const [passwordData, setPasswordData] = useState({
        currentPassword: "",
        changePassword: "",
        newPassword: ""
    });

    const [displayImg, setDisplayImg] = useState('');
    const [filePreview, setFilePreview] = useState(null);

    let { accountId } = useParams();
    accountId = parseInt(accountId, 10);

    const URI_array = window.location.href.split("/");
    const found_word = URI_array[3];

    useEffect(() => {

        if (!userRole) return;

        const endpoint = userRole
            ? `https://docuquest-swu.swucite.tech/api_drts/users.php/${accountId}/`
            : `https://docuquest-swu.swucite.tech/api_drts/clients.php/${accountId}/`;

        switch (found_word) {
            case "profile":
                setTitle("Your Profile");
                break;
            case "manage":
                setTitle("Edit Profile");
                break;
            default:
                break;
        }
        //console.warn("api path: ", endpoint);

        axios.get(endpoint)
            .then((res) => {
                const user = res.data;
                setDisplayData({
                    id: user.id || null,
                    firstname: user.firstname || "",
                    middlename: user.middlename || "",
                    lastname: user.lastname || "",
                    email: user.email || "",
                    phone: user.phone || "",
                    profilePicture: user.img_profile ? user.img_profile : "https://via.placeholder.com/150",
                    accountType: user.account_type || "",
                    oldPassword: user.password || "",
                    user_courses: res.data.user_courses || []
                });
            })
            .catch((err) => {
                notify("error", `Error fetching data for ID ${accountId}, ${err}`);
                setErrorUser({
                  type: "danger",
                  message:`Error fetching data for ID ${accountId}, ${err}` 
                });
            });
    }, [userRole, accountId]);
    // found_word

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setDisplayData({ ...displayData, [name]: value });
    };

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value }); 
    }

    const handleCropImage = () => {
        if (editorRef.current) {
            const canvas = editorRef.current.getImageScaledToCanvas();
            const croppedImage = canvas.toDataURL(); // Convert canvas to base64
            setFilePreview(croppedImage);
        }
    };

    const handleProfilePictureChange = (e) => {
        const file = e.target.files[0];
        const allowedTypes = ["image/jpeg"];

        const MAX_FILE_SIZE_MB = 15; // 15MB Limit
        const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert to Bytes

        if (!file) return;

        if (file && !allowedTypes.includes(file.type)) {
            notify("error", `ERROR: ${file.name} is not a JPG image file!`);
            setErrorPfp({
                type: "danger",
                message: `ERROR: ${file.name} is not a JPG image file!`,
            });
            setFilePreview(null);
            return;
        }

        if (file.size > MAX_FILE_SIZE_BYTES) {
            notify("error", `ERROR: ${file.name} is too large. Image can only be 15MB or below.`);
            setErrorPfp({
                type: "danger",
                message: `ERROR: ${file.name} is too large. Image can only be 15MB or below.`,
            });
            setFilePreview(null);
            return;
        }

        if (file) {
            const fileURL = URL.createObjectURL(file);
            setFilePreview(fileURL);
        } else {
            setFilePreview(null);
        }
    };

    const mapPasswordUser = (data) => ({
        currentPassword: data.currentPassword,
        changePassword: data.changePassword,
        oldPassword: data.oldPassword, 
        newPassword: data.newPassword,
    });

    const mapPasswordClient = (data) => ({
        currentPassword: data.currentPassword,
        changePassword: data.changePassword,
        oldPassword: data.oldPassword,
        newPassword: data.newPassword,
    });

    const handleSubmitPassword = (e) => {
        e.preventDefault();

        if (!userRole) return;

        if (!passwordData.currentPassword || !passwordData.changePassword || !passwordData.newPassword) {
            notify("warning", `You need to enter both your current and new password to proceed.`);
            setErrorPassword({
                type: "warning",
                message: "You need to enter both your current and new password to proceed."
            })
            return;
        }
        
        // Check if New Password and Confirm New Password match
        if (passwordData.changePassword !== passwordData.newPassword) {
            //console.warn("Passwords do not match!");
            setErrorPassword({
                type: "danger",
                message: "New password and confirm new password do not match."
            });
            notify("error", "New password and confirm new password do not match.");
            return;
        }

        const transformedData = userRole !== "" && userRole !== null
        ? mapPasswordUser({...passwordData, oldPassword: displayData.oldPassword})  
        : mapPasswordClient({...passwordData, oldPassword: displayData.oldPassword});
        // console.warn("submitted current: ", transformedData.currentPassword);
        // console.warn("submitted attempt: ", transformedData.changePassword);
        // console.warn("submitted new: ", transformedData.newPassword);

        
        const endpointSetPassword = userRole !== "" && userRole !== null
        ? `https://docuquest-swu.swucite.tech/api_drts/checkPassUser.php/${accountId}/`
        : `https://docuquest-swu.swucite.tech/api_drts/checkPassClient.php/${accountId}/`;
        

        // console.warn("transformedData", transformedData);
        // console.warn("endpointSetPassword", endpointSetPassword);

        axios.post(endpointSetPassword, transformedData, {
            withCredentials: true
        })
        .then((res)=>{
            notify("success", `Password updated`);
            setErrorPassword({
                type: "success",
                message: "Password updated"
            });

            // reset fields
            setPasswordData({
                currentPassword: "",
                changePassword: "",
                newPassword: ""
            });

            navigate('/logout');
        })
        .catch((err)=>{
            notify("error", `Update password failed: ${err}`);
            setErrorPassword({
                type: "danger",
                message: `Update password failed: ${err}`
            });
        })
    }

    const handleSubmitPicture = () => {
        if (!editorRef.current) {
            //console.error("Editor reference is missing!");
            return;
        }
    
        // Crop the image
        const canvas = editorRef.current.getImageScaledToCanvas();
        const croppedImage = canvas.toDataURL("image/jpeg");

        // console.warn("id", accountId);
        // console.warn("pfp", croppedImage);
        
        // Upload cropped profile picture
        axios.post(`https://docuquest-swu.swucite.tech/api_drts/userPicture.php`, {
            userId: accountId,
            file_pfp: croppedImage
        })
        .then((response) => {
            //console.log("Profile picture uploaded :", response.data);
    
            // Update the UI with the new profile picture
            setDisplayData((prevData) => ({
                ...prevData,
                profilePicture: croppedImage, // Show the updated image
            }));
    
            notify("success", `Profile picture updated`);
            // Close modal and reset preview
            setChangePfpModal(false);
            setFilePreview(null);
        })
        .catch((error) => {
            notify("danger", `Error uploading profile picture: ${error}`);
            //console.error("Error uploading profile picture:", error);
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!displayData.firstname || !displayData.lastname || !displayData.phone) {
            notify("warning", `Name and Email fields are required.`);
            setErrorUser({
                type: "warning",
                message: "Name and Email fields are required."
            })
            return;
        }
        
        const endpoint = userRole
            ? `https://docuquest-swu.swucite.tech/api_drts/users.php/${accountId}/`
            : `https://docuquest-swu.swucite.tech/api_drts/clients.php/${accountId}/`;
        
        const editData = {
            userFirstName: displayData.firstname,
            userMiddleName: displayData.middlename,
            userLastName: displayData.lastname,
            userEmail: displayData.email,
            userPhone: displayData.phone,
        }

        // if (userRole) {
        //     editData.userRole = displayData.accountType
        // }

        //console.warn("endpoint: ", endpoint);
        //console.warn("you sent editData:", editData)

        axios.patch(endpoint, editData)
        .then((response) => {
            // fetch user info again
            // console.warn("response: ", response.data)

            axios.get(endpoint)
                .then((res) => {
                    setDisplayData(res.data);

                    notify("success", `Account info updated`);
                    setErrorUser({
                        type: "success",
                        message: "Account info updated"
                    })
                })
                .catch((err) => {
                    notify("error", `Error fetching updated data: ${err}`);
                    setErrorUser({
                        type: "danger",
                        message: `Error fetching updated data: ${err}`
                    })
                });
        })
        .catch((error) => {
            notify("error", `Error updating account: ${error}`);
            setErrorUser({
                type:"danger",
                message: `Error updating account: ${error}`
            })
        });
    };

    return (
        <div className="viewport">
        <div className="profile-container">
            <button className='back-button' onClick={() => navigate(-1)}>Back</button>
            <h1 className="profile-header">{stringTitle}</h1>

            <div className="profile-picture-container">
                {/* display img_profile from db if it is not null */}
                {displayData.profilePicture ? (
                    <div className="mt-4">
                            <img
                                key={displayData.profilePicture}
                                src={displayData.profilePicture}
                                alt="Your pfp"
                                title="Your pfp"
                                className="profile-picture"
                                onError={(e) => { e.target.src = "https://placehold.co/160x160"; }}
                            />

                            <br/>

                            <button className="yellow-button" onClick={() => setChangePfpModal(true)}>Change profile picture</button>
                    </div>
                ) : (
                    // No profile picture ever set
                    <button className="yellow-button" onClick={() => setChangePfpModal(true)}>Set profile picture</button>
                )
                }
                
                  {errorPfp ? (
                    <Alert variant={errorPfp.type}>
                        {errorPfp.message}
                    </Alert>
                  ) : ""
                  }
                                  
                {/* {selectedPfp && (
                  // profile picture already exists
                  <button onClick={() => setChangePfpModal(true)}>Change profile picture</button>
                  ) 
                } */}
            </div>

            <Modal show={changePfpModal} onHide={() => setChangePfpModal(false)} centered>
                <Modal.Header >
                    <Modal.Title>Upload Profile Picture</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <Form.Group>
                      <Form.Label>Select a JPEG Image</Form.Label>
                      <Form.Control
                        // required
                        ref={userPfpRef}
                        type="file"
                        name="file_pfp"
                        accept="image/jpeg"
                        onChange={handleProfilePictureChange}
                      />
                    </Form.Group>

                    {filePreview && (
                        <div className="image-editor-container">
                            <AvatarEditor
                                ref={editorRef}
                                image={filePreview}
                                width={250}
                                height={250}
                                border={50}
                                borderRadius={125} // Circular cropping
                                color={[255, 255, 255, 0.6]} // Background color
                                scale={scale}
                                rotate={0}
                            />
                            <input
                                type="range"
                                min="1"
                                max="3"
                                step="0.1"
                                value={scale}
                                onChange={(e) => setScale(parseFloat(e.target.value))}
                            />
                        </div>
                    )}
                    
                    <Button 
                      variant="primary"
                      type="button"
                      className="mt-3"
                      onClick={handleSubmitPicture}
                      disabled={!filePreview}
                    >
                      Submit Profile Picture
                    </Button>
                  </Form>
                </Modal.Body>
            </Modal>

            <form onSubmit={handleSubmit}>
                {/* <br>
                </br>
                <br>
                </br> */}
                <h3>{displayData.accountType}</h3>
                
                {displayData.user_courses && displayData.user_courses.length > 0 ? (
                        <div className="profile-section">
                            <label>Assigned Courses:</label>
                            <p>{displayData.user_courses.join(", ")}</p>
                        </div>
                    ) : (
                        <div className="profile-section">
                            <label>Courses:</label>
                            <p>No courses assigned</p>
                        </div>
                    )
                }

                {errorUser ? (
                    <Alert variant={errorUser.type}>
                        {errorUser.message}
                    </Alert>
                ): ""
                }

                <div className="profile-section">
                    <label htmlFor="name">First name:</label>
                    <input
                        type="text"
                        id="firstname"
                        name="firstname"
                        value={displayData.firstname}
                        onChange={handleInputChange}
                    />
                </div>

                <div className="profile-section">
                    <label htmlFor="name">Middle name:</label>
                    <input
                        type="text"
                        id="middlename"
                        name="middlename"
                        value={displayData.middlename}
                        onChange={handleInputChange}
                    />
                </div>

                <div className="profile-section">
                    <label htmlFor="name">Last name:</label>
                    <input
                        type="text"
                        id="lastname"
                        name="lastname"
                        value={displayData.lastname}
                        onChange={handleInputChange}
                    />
                </div>

                <div className="profile-section">
                    <label htmlFor="email">Email:</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        value={displayData.email}
                        onChange={handleInputChange}
                    />
                </div>
                <div className="profile-section">
                    <label htmlFor="phone">Phone:</label>
                    <input
                        type="text"
                        id="phone"
                        name="phone"
                        value={displayData.phone}
                        onChange={handleInputChange}
                    />
                </div>

                {/* TODO found_word == manage, show extra fields for role and verified */}
                {/* <div className="profile-section">
                    <button className="save-button" type="submit">
                        Save
                    </button>
                </div> */}
                <button className="save-button" type="submit">
                    Save
                </button>
            </form>

            {userIdRef.current === displayData.id  && (
            <form onSubmit={handleSubmitPassword}>
                <fieldset>
                    <legend>Change Password</legend>
                    {/* TODO rules for setting passwords */}
                    {errorPassword ? (
                        <Alert variant={errorPassword.type}>
                            {errorPassword.message}
                        </Alert>
                    ) : ""
                    }
                    <div className="profile-section">
                    <label htmlFor="currentPassword">Current Password:</label>
                        <input
                            required
                            type="password"
                            id="currentPassword"
                            name="currentPassword"
                            placeholder="Enter current password"
                            value={passwordData.currentPassword}
                            onChange={handlePasswordChange}
                        />
                    </div>

                    <div className="profile-section">
                        <label htmlFor="changePassword">New Password:</label>
                        <input
                            required
                            type="password"
                            id="changePassword"
                            name="changePassword"
                            placeholder="Enter new password"
                            value={passwordData.changePassword}
                            onChange={handlePasswordChange}
                        />
                    </div>

                    <div className="profile-section">
                        <label htmlFor="newPassword">Confirm New Password:</label>
                        <input
                            required
                            type="password"
                            id="newPassword"
                            name="newPassword"
                            placeholder="Confirm new password"
                            value={passwordData.newPassword} 
                            onChange={handlePasswordChange}
                        />
                    </div>

                    {/* profile-section */}
                    <div className="button-container">
                    <button className="save-button" type="submit">
                        Change your password
                    </button>
                    </div>         
                </fieldset>  
            </form>
            )}

            {/* <form onSubmit={handleSubmitPassword}>
                <fieldset>
                    <legend>Change Password</legend>

                    {errorPassword ? (
                        <Alert variant={errorPassword.type}>
                            {errorPassword.message}
                        </Alert>
                    ) : ""
                    }
                    <div className="profile-section">
                    <label htmlFor="currentPassword">Current Password:</label>
                        <input
                            required
                            type="password"
                            id="currentPassword"
                            name="currentPassword"
                            placeholder="Enter current password"
                            value={passwordData.currentPassword}
                            onChange={handlePasswordChange}
                        />
                    </div>

                    <div className="profile-section">
                        <label htmlFor="changePassword">New Password:</label>
                        <input
                            required
                            type="password"
                            id="changePassword"
                            name="changePassword"
                            placeholder="Enter new password"
                            value={passwordData.changePassword}
                            onChange={handlePasswordChange}
                        />
                    </div>

                    <div className="profile-section">
                        <label htmlFor="newPassword">Confirm New Password:</label>
                        <input
                            required
                            type="password"
                            id="newPassword"
                            name="newPassword"
                            placeholder="Confirm new password"
                            value={passwordData.newPassword} 
                            onChange={handlePasswordChange}
                        />
                    </div>


                    <div className="button-container">
                    <button className="save-button" type="submit">
                        Change your password
                    </button>
                    </div>         
                </fieldset>

                
            </form> */}
            <ToastContainer newestOnTop/>
        </div>
        </div>
    );
}
